import React from "react";

const ErrorsInfo = ({ data, title }) => {
	return (
		<div className="col-md-12">
			<h5 className="mb-2 mt-3">{title}</h5>
			<div>
				{data.map((item, i) => (
					<li key={i}>
						<div className="d-flex justify-content-between">
							<span>
								<i
									className={
										item?.status === "Failed"
											? "bx bx-x-circle checks-error m-2"
											: "bx bx-check-circle checks-success m-2"
									}
								></i>
								<strong>{item?.message}</strong>
							</span>
						</div>
					</li>
				))}
			</div>
		</div>
	);
};

export default ErrorsInfo;
